export const themes = {
  emerald: { accent: "#1A362D", secondary: "#F4EFE6", band: "#1A362D", bg: "#FDFBF7", overlay: "rgba(0,0,0,0.45)" },
  blush: { accent: "#7D3C4A", secondary: "#FBEEF0", band: "#5C2B36", bg: "#FFF9F7", overlay: "rgba(40,10,20,0.42)" },
  midnight: { accent: "#1E293B", secondary: "#EEF2F7", band: "#0F172A", bg: "#F8FAFC", overlay: "rgba(0,0,0,0.5)" },
  sand: { accent: "#8A6D3B", secondary: "#F7F1E6", band: "#3D3320", bg: "#FDFBF5", overlay: "rgba(30,20,0,0.4)" },
};

export const themeOptions = [
  { value: "emerald", label: "Emerald & Ivory" },
  { value: "blush", label: "Blush & Rose" },
  { value: "midnight", label: "Midnight Blue" },
  { value: "sand", label: "Sand & Gold" },
];
